import { Injectable } from '@angular/core';
import { Router, Route } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';

import { LsHelperService } from 'src/app/core/services/ls-helper.service';

import { Subject } from 'rxjs';

import firebase from 'firebase/app';
import 'firebase/database';
import { AuthService } from 'src/app/core/services/auth.service';

@Injectable({
	providedIn: 'root'
})
export class NotificationService extends BaseProvider {
	roles: any = [];
	showManagement = false;
	item: any = {};
	messageCount = 0;
	messages: any;
	isLoading = false;

	showNotifications = false;

	notificationRefresh = new Subject();

	constructor(
		public router: Router,
		public globals: GlobalsService,
		public http: HttpClient,
		public ls: LsHelperService,
		private authService: AuthService
	) {
		super();

		this.baseUrl = 'messaging';
	}

	loadMessagingCount() {

		const userId = this.ls.get('userId');

		if (userId) {
			// this.firebasedb  = firebase
			// 		.database()
			// 		.ref('messaging/' + userId + '/info');

			// this.firebasedb.on("value", (resp)=> {
			// 	this.getCount();
			// });
		}
	}

	get() {
		this.isLoading = true;

		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl;

			const loginData = this.ls.get('loginData');

			this.http.get(
				this.url
			)
				.subscribe(
					(data: any) => {
						this.isLoading = false;
						this.list = data.Data;

						resolve(data.Data);
					},
					err => { reject(err); }
				);
		});
	}

	getCount() {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/count';

			const loginData = this.ls.get('loginData');

			this.http.get(
				this.url
			)
				.subscribe(
					(data: any) => {
						this.messageCount = data.Data ? data.Data : 0;
						console.log('this.messageCount: ' + this.messageCount);
						resolve(this.messageCount);
					},
					err => { reject(err); }
				);
		});
	}

	updateSeen(params) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/seen/' + params.Id;

			this.http
				.put(this.url, params)
				.subscribe(
					(data: any) => {
						if (!params.Seen) {
							this.messageCount--;
						}

						this.gotoUrl(params);
						resolve(data);
					},
					err => { reject(err); }
				);
		});
	}

	gotoUrl(item) {
		// let url = item.UriPathTemplate;
		// url = url.replace('{0}', item.EntityId);
		// this.router.navigate([url]);

		if (this.authService.hasRole('tecnico interno')) {
			this.router.navigate(['/transactions-admin/', item.EntityId]).finally(() => {
				window.location.reload();
			});
		} else {
			this.router.navigate([item.UriPathTemplate.replace('{0}', item.EntityId)]);
		}
	}

	clearInbox() {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/clear';

			this.http
				.put(this.url, {})
				.subscribe(
					(data: any) => {

						this.list = [];

						resolve(data);
					},
					err => { reject(err); }
				);
		});
	}

	deleteMessage(messageId) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + `/${messageId}`;

			this.http
				.delete(
					this.url
				)
				.subscribe(
					(data: any) => {
						this.list = this.list.filter(function(e) {
							return e.Id !== messageId;
						});

						resolve(data);
					},
					err => { reject(err); }
				);
		});
	}
}
